import type {
  DMCoreSpaceOperatorLoginResponse,
  DMCoreSpaceOperatorTokenRefreshResponse
} from '#src/interfaces/DMCoreSpaceOperator'

export const isDMCoreSpaceOperatorLoginResponse = (
  data: DMCoreSpaceOperatorLoginResponse | DMCoreSpaceOperatorTokenRefreshResponse
): data is DMCoreSpaceOperatorLoginResponse => {
  return 'permission_category_group_claims' in data
}
